import axios from 'axios';
const { MIX_MIMED_BFF_URL } = process.env;
/**
 * Actionn que solicita el código OTP vía SMS con uso del RUT del usuario
 * @param {*} store
 * @param {*} payload
 */
export const createSmsCode = async ({ commit }, payload) => {
  try {
    const { data, status } = await axios.post(`${MIX_MIMED_BFF_URL}api/v1/users/account/notify`, payload);
    if(status === 201 ) {
      const isObject = (obj) => {
        return obj !== undefined && obj !== null && obj.constructor == Object;
      };

      const smsState = {
        smsData: {
          "oid": data.oid,
          "phone": data.phone,
        },
        isObject: isObject(data),
      };
      commit('setSmsInfo', smsState);
      commit('setUserNotFound', false);
    }

  } catch (error) {
    if (error.response) {
      const response = error.response.data;
      if (response && response.statusCode === 404) {
        commit('setUserNotFound', true);
      } else if   (response && response.statusCode === 406) {
        commit('setUserIsBlocked', true);
      }
      commit('setSmsInfo', undefined);
    }
    commit('setSmsInfo', undefined);
  }
};

/**
 * Action que valida el OTP ingresado por el usuario
 * @param {*} store
 * @param {*} payload
 */
export const validateOtp = async ({ commit }, payload) => {
  try {
    const { data, status } = await axios.post(`${MIX_MIMED_BFF_URL}api/v1/users/account/verify`, payload);
    if(status === 200) {
      commit('setSmsValidated', data.email)
    }
  }catch (error) {
    console.error(error || error.message);
  }
}

/**
 * Action para obtener el estado inicial de la solicitud del usuario
 * Aqui se valida los intentos realizados por un usuario
 * para asegurar el estado inicial del componente.
 * @param {*} store
 * @param {*} payload
 */
export const calculateInitialState = async ({ commit }, payload ) => {
  try {
    const { data, status } = await axios.get(`${MIX_MIMED_BFF_URL}api/v1/users/sms-state/${payload.rut}`);
    if(status === 200) {
      commit('setInitialSmsState', data);
      commit('setUserNotFound', false);
    }
  }catch (error) {
    if (error.response) {
      const { data }  = error.response;
      if (data && data.statusCode === 404) {
        commit('setUserNotFound', true);
      } else if   (data && data.statusCode === 406) {
        commit('setUserIsBlocked', true);
      }
    }
    commit('setInitialSmsState', undefined);
  }
}

export const persistNewStateRetry = async ({ commit, state }, payload) => {
  const initialSmsState = state.validationSmsData;
  const newState = {
    userRetries: payload.currentRetry,
    timesValidationFail: initialSmsState.timesValidationFail,
    lastUpdate: new Date().toISOString(),
    createdAt: initialSmsState.createdAt ? initialSmsState.createdAt : new Date().toISOString(),
    rut: payload.rut
  }

  try {
    const  { data, status } = await axios.post(`${MIX_MIMED_BFF_URL}api/v1/users/sms-state`, newState);
    if (status === 201) {
      commit('setPersistedState', data);
    }
  } catch (err) {
    console.error(err);
  }
}

export const persistNewStateValidate = async ({ commit, state }, payload) => {
  const initialSmsState = state.validationSmsData;
  const newState = {
    userRetries: initialSmsState.userRetries,
    timesValidationFail: payload.timesValidationFail,
    lastUpdate: new Date().toISOString(),
    createdAt: initialSmsState.createdAt ? initialSmsState.createdAt : new Date().toISOString(),
    otpCode: [Number(payload.otpCode)],
    rut: payload.rut
  }
  try {
    const  { data, status } = await axios.post(`${MIX_MIMED_BFF_URL}api/v1/users/sms-state`, newState);
    if (status === 201) {
      commit('setPersistedState', data);
    }
  } catch (err) {
    console.error(err);
  }
}
